import axios from "axios";
import React from "react";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import trackingEventDictionary from "../../../src/core/dictionary/tracking-event";
import "../../assets/scss/global.scss";
import "../../assets/scss/intel.scss";
import { getCompanyComingFrom, globalPendoEventForCompanyRedirection } from "../../core/global/global-country-functions";
import { getApiUrl } from "../../utils/baseUrl";
import { getIntelUrl } from "../../utils/intelUrl";
import { generateQueryString } from "../../core/utility/utility";
import { setRedirectionIdsArrayHandler } from "@redux/User/userDetailsSlice";
import { connect } from "react-redux";
const websitelAPIEndpoints = {
  getCompanySlug: getApiUrl("companyProfiles/getSlug"),
};

class ShipmentsCompanyName extends React.Component {
  state = { showAll: false };

  navigateUserToCompanyProfile = (data) => {
    if (!!this && this.props && this.props.name && this.props.name.toLowerCase().includes("consignee")) {
      globalPendoEventForCompanyRedirection(this.props.shipmentConsigneeStandardizedName, this.props.isRedirect, this.props.redirectingCompanyExporterId, this.props.redirectingCompanyImporterId, this.props.redirectingCompanyLogisticsId, this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan);
    } else if (!!this && this.props && this.props.name && this.props.name.toLowerCase().includes("shipper")) {
      globalPendoEventForCompanyRedirection(this.props.shipmentShipperStandardizedName, this.props.isRedirect, this.props.redirectingCompanyExporterId, this.props.redirectingCompanyImporterId, this.props.redirectingCompanyLogisticsId, this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan);
    } else {
      globalPendoEventForCompanyRedirection(this.props.shipmentLogisticsStandardizedName, this.props.isRedirect, this.props.redirectingCompanyExporterId, this.props.redirectingCompanyImporterId, this.props.redirectingCompanyLogisticsId, this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan);
    }
    if (!(!!data.rowData && !!data.rowData[data.companyIdKey] && data.rowData[data.companyIdKey] !== "")) {
      toast.error("Data not found. Please try again later !!!");
      return false;
    }
    const companyId = data.rowData[data.companyIdKey];
    this.props.setRedirectionIdsArrayHandler(companyId);
    let params = {
      companyId: companyId,
    };
    if (!!data && !!data.companyType && data.companyType !== "") {
      params.type = data.companyType;
    }
    let tempCompanyName = "";
    if (!!this.props.rowData && !!this.props.companyIdKey && this.props.companyIdKey !== "" && this.props.rowData[this.props.companyIdKey]) {
      if (this.props.derivedCompanyKey && !!this.props.rowData[this.props.derivedCompanyKey] && this.props.rowData[this.props.derivedCompanyKey] !== "") {
        tempCompanyName = !!this.props && !!this.props.rowData[this.props.derivedCompanyKey] && this.props.rowData[this.props.derivedCompanyKey] !== "" ? this.props.rowData[this.props.derivedCompanyKey] : "";
      } else {
        if (this.props.companyKey && !!this.props.rowData[this.props.companyKey] && this.props.rowData[this.props.companyKey] !== "") {
          tempCompanyName = !!this.props && !!this.props.rowData[this.props.companyKey] && this.props.rowData[this.props.companyKey] !== "" ? this.props.rowData[this.props.companyKey] : "";
        } else {
          tempCompanyName = "NA";
        }
      }
    } else {
      if (this.props.derivedCompanyKey && !!this.props.rowData[this.props.derivedCompanyKey] && this.props.rowData[this.props.derivedCompanyKey] !== "") {
        tempCompanyName = !!this.props && !!this.props.rowData[this.props.companyKey] && this.props.rowData[this.props.companyKey] !== "" ? this.props.rowData[this.props.companyKey] : "";
      } else if (this.props.companyKey && !!this.props.rowData[this.props.companyKey] && this.props.rowData[this.props.companyKey] !== "") {
        tempCompanyName = !!this.props && !!this.props.rowData[this.props.companyKey] && this.props.rowData[this.props.companyKey] !== "" ? this.props.rowData[this.props.companyKey] : "";
      } else {
        tempCompanyName = "NA";
      }
    }
    let tempPathName = this.props.pathname + "%%" + companyId + "%%" + tempCompanyName;
    axios
      .get(websitelAPIEndpoints.getCompanySlug, { params })
      .then((res) => {
        if (!!res && !!res.data && !!res.data.status && res.data.status.toUpperCase() === "success".toUpperCase()) {
          if (!!res.data.data && !!res.data.data.companySlug && res.data.data.companySlug !== "") {
            let url = "";
            let queryParams = {
              country: this.props.countryName ? (this.props.countryName.toUpperCase() === "US" ? this.props.countryName.toUpperCase() : this.props.countryName.toLowerCase() === "united kingdom" ? "uk" : this.props.countryName.toLowerCase()) : "colombia",
              type: this.props.countryType ? this.props.countryType.toLowerCase() : "export",
              tab: this.props.name && this.props.name.toLowerCase().includes("shipper") ? "E" : "I",
            };
            if (!!this && !!this.props && !!this.props.type && this.props.type !== "") {
              queryParams.comingFrom = getCompanyComingFrom(this.props.type);
            }
            let queryString = generateQueryString(queryParams);
            url = getIntelUrl() + "companies/" + res.data.data.companySlug + "/" + res.data.data.aliasCompanyId + "?" + queryString;
            if (!!url && url !== "") {
              window.open(url, "_blank");
            } else {
              toast.error("Something went wrong. Please try again later !!!");
            }
          } else {
            globalPendoEventForCompanyRedirection(trackingEventDictionary.noCompanyFound, this.props.isRedirect, this.props.redirectingCompanyExporterId, this.props.redirectingCompanyImporterId, this.props.redirectingCompanyLogisticsId, this.props.analyticsCountryID, tempPathName, this.props.currentUserPlan);
            toast.error("No company profile found in our system !!!");
          }
        } else {
          globalPendoEventForCompanyRedirection(trackingEventDictionary.noCompanyFound, this.props.isRedirect, this.props.redirectingCompanyExporterId, this.props.redirectingCompanyImporterId, this.props.redirectingCompanyLogisticsId, this.props.analyticsCountryID, tempPathName, this.props.currentUserPlan);
          toast.error("No company profile found in our system !!!");
        }
      })
      .catch(() => {
        toast.error("Something went wrong. Please try again later !!!");
      });
  };

  renderArrayEntries = (names, companyIds) => {
    const entries = names.map((name, idx) => ({ name, companyId: companyIds[idx] || null })).filter((e) => e.name && typeof e.name === "string" && e.name.trim() !== "");

    if (entries.length === 0) return <span>NA</span>;

    const linkClass = this.props.from === "view-ship" ? "btn-link trademo-link py-0 text-capitalize" : "btn-link trademo-link text-capitalize";
    const visibleEntries = this.state.showAll ? entries : entries.slice(0, 3);

    return (
      <span style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
        {visibleEntries.map((entry, idx) => {
          const tooltipId = "shipment-company-array-tooltip";
          const displayName = entry.name.length > 50 ? entry.name.slice(0, 50) : entry.name;
          const isVisited = entry.companyId && this.props.redirectionIdsArr.includes(entry.companyId);

          const syntheticData = {
            ...this.props,
            rowData: { ...this.props.rowData, [this.props.companyIdKey]: entry.companyId },
          };

          return (
            <span key={idx} style={{ display: "block" }}>
              {entry.companyId ? (
                <span className="w-100 m-0" data-for={tooltipId} data-tip={entry.name.length > 50 ? entry.name : ""}>
                  <a className={`${linkClass}${isVisited ? " text_visited" : ""}`} onClick={this.navigateUserToCompanyProfile.bind(this, syntheticData)}>
                    {displayName}
                    {entry.name.length > 50 && <span>...</span>}
                  </a>
                </span>
              ) : (
                <span className="w-100 m-0 text-capitalize" data-for={tooltipId} data-tip={entry.name.length > 50 ? entry.name : ""}>
                  {displayName}
                  {entry.name.length > 50 && <span>...</span>}
                </span>
              )}
            </span>
          );
        })}
        {entries.length > 3 && (
          <a
            className="btn-link trademo-link"
            style={{ fontSize: "12px", marginTop: "2px" }}
            onClick={(e) => {
              e.stopPropagation();
              this.setState((s) => ({ showAll: !s.showAll }));
            }}>
            {this.state.showAll ? "Show less" : `+${entries.length - 3} more`}
          </a>
        )}
      </span>
    );
  };

  render() {
    const { rowData, companyIdKey, derivedCompanyKey, companyKey } = this.props;

    const nameValue = derivedCompanyKey && rowData[derivedCompanyKey] ? rowData[derivedCompanyKey] : companyKey && rowData[companyKey] ? rowData[companyKey] : null;
    const companyIdValue = companyIdKey && rowData[companyIdKey] ? rowData[companyIdKey] : null;

    if (Array.isArray(nameValue) || Array.isArray(companyIdValue)) {
      const names = Array.isArray(nameValue) ? nameValue : nameValue ? [nameValue] : [];
      const companyIds = Array.isArray(companyIdValue) ? companyIdValue : companyIdValue ? [companyIdValue] : [];
      return this.renderArrayEntries(names, companyIds);
    }

    return (
      <span>
        <span>
          {!!this.props.rowData && !!this.props.companyIdKey && this.props.companyIdKey !== "" && this.props.rowData[this.props.companyIdKey] ? (
            this.props.derivedCompanyKey && !!this.props.rowData[this.props.derivedCompanyKey] && this.props.rowData[this.props.derivedCompanyKey] !== "" ? (
              <span className="w-100 m-0" data-for="id_1" data-tip={!!this.props && !!this.props.rowData[this.props.derivedCompanyKey] && this.props.rowData[this.props.derivedCompanyKey] !== "" && this.props.rowData[this.props.derivedCompanyKey].length > 50 ? this.props.rowData[this.props.derivedCompanyKey] : ""}>
                <a className={`${this.props.from && this.props.from === "view-ship" ? "btn-link trademo-link py-0 text-capitalize" : "btn-link trademo-link text-capitalize"}${this.props.redirectionIdsArr.includes(this.props.rowData[this.props.companyIdKey]) ? " text_visited" : ""}`} onClick={this.navigateUserToCompanyProfile.bind(this, this.props)}>
                  {!!this.props && this.props.rowData[this.props.derivedCompanyKey] && this.props.rowData[this.props.derivedCompanyKey].length > 50 ? this.props.rowData[this.props.derivedCompanyKey].slice(0, 50) : this.props.rowData[this.props.derivedCompanyKey]}
                  {!!this.props && this.props.rowData[this.props.derivedCompanyKey] && this.props.rowData[this.props.derivedCompanyKey].length > 50 ? <span>...</span> : <></>}
                </a>
              </span>
            ) : this.props.companyKey && !!this.props.rowData[this.props.companyKey] && this.props.rowData[this.props.companyKey] !== "" ? (
              <span className="w-100 m-0" data-for="id_4" data-tip={!!this.props && !!this.props.rowData[this.props.companyKey] && this.props.rowData[this.props.companyKey] !== "" && this.props.rowData[this.props.companyKey].length > 50 ? this.props.rowData[this.props.companyKey] : ""}>
                <a className={`${this.props.from && this.props.from === "view-ship" ? "btn-link trademo-link py-0 text-capitalize" : "btn-link trademo-link text-capitalize"}${this.props.redirectionIdsArr.includes(this.props.rowData[this.props.companyIdKey]) ? " text_visited" : ""}`} onClick={this.navigateUserToCompanyProfile.bind(this, this.props)}>
                  {!!this.props && this.props.rowData[this.props.companyKey] && this.props.rowData[this.props.companyKey].length > 50 ? this.props.rowData[this.props.companyKey].slice(0, 50) : this.props.rowData[this.props.companyKey]}
                  {!!this.props && this.props.rowData[this.props.companyKey] && this.props.rowData[this.props.companyKey].length > 50 ? <span>...</span> : <></>}
                </a>
              </span>
            ) : (
              "NA"
            )
          ) : (
            <span>
              {this.props.derivedCompanyKey && !!this.props.rowData[this.props.derivedCompanyKey] && this.props.rowData[this.props.derivedCompanyKey] !== "" ? (
                <span className="w-100 m-0" data-for="id_2" data-tip={!!this.props && !!this.props.rowData[this.props.derivedCompanyKey] && this.props.rowData[this.props.derivedCompanyKey] !== "" && this.props.rowData[this.props.derivedCompanyKey].length > 50 ? this.props.rowData[this.props.derivedCompanyKey] : ""}>
                  <span className="text-capitalize">
                    {!!this.props && this.props.rowData[this.props.derivedCompanyKey] && this.props.rowData[this.props.derivedCompanyKey].length > 50 ? this.props.rowData[this.props.derivedCompanyKey].slice(0, 50) : this.props.rowData[this.props.derivedCompanyKey]}
                    {!!this.props && this.props.rowData[this.props.derivedCompanyKey] && this.props.rowData[this.props.derivedCompanyKey].length > 50 ? <span>...</span> : <></>}
                  </span>
                </span>
              ) : this.props.companyKey && !!this.props.rowData[this.props.companyKey] && this.props.rowData[this.props.companyKey] !== "" ? (
                <span className="w-100 m-0" data-for="id_3" data-tip={!!this.props && !!this.props.rowData[this.props.companyKey] && this.props.rowData[this.props.companyKey] !== "" && this.props.rowData[this.props.companyKey].length > 50 ? this.props.rowData[this.props.companyKey] : ""}>
                  <span className="text-capitalize">
                    {!!this.props && this.props.rowData[this.props.companyKey] && this.props.rowData[this.props.companyKey].length > 50 ? this.props.rowData[this.props.companyKey].slice(0, 50) : this.props.rowData[this.props.companyKey]}
                    {!!this.props && this.props.rowData[this.props.companyKey] && this.props.rowData[this.props.companyKey].length > 50 ? <span>...</span> : <></>}
                  </span>
                </span>
              ) : (
                "NA"
              )}
            </span>
          )}
        </span>
      </span>
    );
  }
}
function mapStateToProps(state) {
  const { userDetails } = state;
  return { redirectionIdsArr: userDetails?.redirectionIdsArr ?? [] };
}
const mapDispatchToProps = {
  setRedirectionIdsArrayHandler: (data) => setRedirectionIdsArrayHandler(data),
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ShipmentsCompanyName));
